const stringOrderingAlphabet = (key1: string, key2: string) => {
    return key1.toLowerCase().localeCompare(key2.toLowerCase());
};

export default stringOrderingAlphabet;
